import axios from "../axios";

const api = {
  getAllCSRDQuestionnaires(queryParams, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/csrd-questionnaires?${queryParams}`, config).then(({ data }) => data);
  },

  createCSRDQuestionnaire(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/csrd-questionnaires", data, headers).then(({ data }) => data);
  },

  updateCSRDQuestionnaire({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/csrd-questionnaires/${id}`, data, headers).then(({ data }) => data);
  },

  deleteCSRDQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/csrd-questionnaires/${id}`, headers).then(({ data }) => data);
  },

  finaliseCSRDQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/csrd-questionnaires/${id}/finalize`, {}, headers).then(({ data }) => data);
  },

  unfinaliseCSRDQuestionnaire(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/csrd-questionnaires/${id}/unfinalize`, {}, headers)
      .then(({ data }) => data);
  },

  getCSRDQuestionnaireDataById(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/csrd-questionnaires-data/${id}`, headers).then(({ data }) => data);
  },

  updateCSRDQuestionnaireDataById({ id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/csrd-questionnaires-data/${id}`, data, headers)
      .then(({ data }) => data);
  },

  getCSRDQuestionnaireDataComments(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/csrd-questionnaires-data/comments", config).then(({ data }) => data);
  },

  getCSRDReport(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/csrd-questionnaires-data/questions", config).then(({ data }) => data);
  },

  getAllCSRDAnswersByQuestionId(params, accessToken) {
    const config = {
      params: {
        year: params.year
      },
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/csrd-questionnaires-data/questions/${params.questionId}/answers`, config).then(({ data }) => data);
  },

  getCSRDQuestionsByType(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/csrd-questions", config).then(({ data }) => data);
  },

  getCSRDFiles(params, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/attachments/questionnaire/csrd/files", config).then(({ data }) => data);
  },

  attachCSRDFile({ type, year, data }, accessToken) {
    const headers = {
      params: {
        type: type,
        year: year
      },
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/attachments/questionnaire/csrd`, data, headers).then(({ data }) => data);
  },

  exportCSRDReport(params, accessToken) {
    const config = {
      params: params,
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/csrd-questionnaires-data/export", config).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = headers["content-disposition"]?.split("filename=")?.[1] ??
        "CSRD Report data export";
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },

  getCSRDProgressByYear(params, accessToken) {
    const headers = { params, headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/csrd-questionnaires-data/progress`, headers).then(({ data }) => data);
  },
};

export default api;